import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const user = localStorage.getItem("user");

  console.log("ProtectedRoute user:", user);

  if (!user) {
    console.log("BLOCKED → redirect to login");
    return <Navigate to="/" replace />;
  }

  console.log("ALLOWED → show app");
  return children;
}
